export default "__VITE_ASSET__B4wIe0tv__"